module.exports = __webpack_public_path__ + "static/26-4a3b2e5a476fe216250a65e57721577e.jpg";